
import React, { useState, useEffect, useRef } from "react";
import Management5 from "../Accountandhistory/Food/Management5";
import { Link } from 'react-router-dom';
import Foodandbeveragesadvertise from "./Foodandbeveragesadvertise";
import Vedioadvertisments from '../PromotionsandDiscounts/Food/Vedioadvertisments';
import Topratings from '../PromotionsandDiscounts/Food/Topratings';
import './Foodandbeverags.css';
function Foodandbeveragespromotions() {
    const [activeTab, setActiveTab] = useState("first"); // default tab
    const isMobile = window.innerWidth <= 768;

    const [isPaused, setIsPaused] = useState(false);

    const scrollRef = useRef(null);
    useEffect(() => {
        const scrollContainer = scrollRef.current;
        let scrollInterval;

        if (scrollContainer && !isPaused) {
            scrollInterval = setInterval(() => {
                if (
                    scrollContainer.scrollTop + scrollContainer.clientHeight >=
                    scrollContainer.scrollHeight
                ) {
                    scrollContainer.scrollTop = 0;
                } else {
                    scrollContainer.scrollTop += 1; // scroll speed
                }
            }, 50);
        }

        return () => clearInterval(scrollInterval);
    }, [isPaused]); // pause state control karega




    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"> </div>
                <div className="col-lg-7">  <div
                    style={{
                        width: "100%",
                        maxWidth: "100vw",
                        // margin: '150px 230px',
                        marginTop: "150px",
                        fontFamily: "Arial, sans-serif",
                    }}
                    className="food-promtoions"
                >
                    <p
                        className="breadcrumb maamaas-home-bredcum"
                        style={{
                            position: "fixed",
                            top: window.innerWidth <= 425 ? " 60px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "64px" : "75px",
                            left: "2vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                            padding: "10px 0",
                            fontSize: isMobile ? "16px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        {/* <Link
                            to="/Newmainlandingpage"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link> */}

                        {/* <span className="separator"> &gt; </span> */}
                        <Link
                            to="/fooddashboard"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Food & Beverages
                        </Link><span className="separator"> &gt; </span>
                        <Link

                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Promotions_Discounts
                        </Link>


                    </p>
                    {/* Tabs Header */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: window.innerWidth <= 650 ? "column" : "row", // 👈 stack vertically on mobile
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "20px",
                            // paddingTop: window.innerWidth >=756 &&  window.innerWidth <= 900 ? "40px" : "-20px",
                        }}
                    >
                        <button
                            onClick={() => setActiveTab("first")}
                            style={{
                                padding: "10px 20px",
                                cursor: "pointer",
                                border: "1px solid rgb(177 93 198)",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                backgroundColor: activeTab === "first" ? "rgb(177 93 198)" : "white",
                                color: activeTab === "first" ? "white" : "rgb(177 93 198)",
                                transition: "0.3s",
                                width: window.innerWidth <= 768 ? "200px" : "auto",
                            }}
                        >
                            Coupns_Offers
                        </button>

                        <button
                            onClick={() => setActiveTab("second")}
                            style={{
                                padding: "10px 20px",
                                cursor: "pointer",
                                border: "1px solid rgb(177 93 198)",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                backgroundColor: activeTab === "second" ? "rgb(177 93 198)" : "white",
                                color: activeTab === "second" ? "white" : "rgb(177 93 198)",
                                transition: "0.3s",
                                width: window.innerWidth <= 768 ? "200px" : "auto",
                            }}
                        >
                            Adevertisements
                        </button>
                        <button
                            onClick={() => setActiveTab("third")}
                            style={{
                                padding: "10px 20px",
                                cursor: "pointer",
                                border: "1px solid rgb(177 93 198)",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                backgroundColor: activeTab === "third" ? "rgb(177 93 198)" : "white",
                                color: activeTab === "third" ? "white" : "rgb(177 93 198)",
                                transition: "0.3s",
                                width: window.innerWidth <= 768 ? "200px" : "auto",
                            }}
                        >
                            Top_Restaurant
                        </button>

                    </div>

                    {/* Tabs Content third */}
                    <div

                    >
                        {activeTab === "first" && <Management5 />}
                        {activeTab === "second" && <Vedioadvertisments />}
                        {activeTab === "third" && <Topratings />}

                    </div>


                    <div className="addhide">
                        <Foodandbeveragesadvertise />
                        {/* <Cateringscrollingorder /> */}
                    </div>
                </div>
                </div>
                <div className="col-lg-3"> </div>
            </div>
            <style>
                {`
                @media(max-width:991px){
                .addhide{
                display:none;
                }
                }
                 @media (min-width: 769px) and (max-width: 1000px) {
            .reports-data-analysis {
                margin-top: 100px !important;
            }
        }
                `}
            </style>
        </div>

    );
}

export default Foodandbeveragespromotions;
